// extracted by mini-css-extract-plugin
module.exports = {"count":"Reservations_count__B3p1B","container":"Reservations_container__2803D","navigator":"Reservations_navigator__qYNni","active":"Reservations_active__1-UA0"};